import { Grid, Typography } from '@mui/material';
import { Fragment, ReactNode } from 'react';

type Props = {
  infos: Info[];
};

type Info = {
  label: string | ReactNode;
  value: ReactNode;
  error?: boolean;
};

export default function InfoGrid({ infos }: Props) {
  return (
    <Grid container spacing={{ xs: 0, md: 2 }} py={3}>
      {infos.map((info, index) => (
        <Fragment key={index}>
          <Grid item xs={12} md={6}>
            {typeof info.label === 'string' ? (
              <Typography variant="subtitle2">{info.label}</Typography>
            ) : (
              info.label
            )}
          </Grid>
          <Grid item xs={12} md={6} mb={{ xs: 2, md: 0 }}>
            {typeof info.value === 'string' ? (
              <Typography
                variant={info.error ? 'subtitle2' : 'caption'}
                color={info.error ? 'error.main' : ''}
                fontWeight={info.error ? 'bold' : 'normal'}
              >
                {info.value}
              </Typography>
            ) : (
              info.value
            )}
          </Grid>
        </Fragment>
      ))}
    </Grid>
  );
}
